import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CompanyForm from "../Companies/CompanyForm";
import {Button, Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {createSelector} from 'reselect/es';
import {getMyCompany, updateCompany} from "../../actions/companies";
import {withLoading, withLoading2} from "../Boilerplate/deferLoaderHoc";
import Spinner from "react-spinkit";

class _CompanyProfileEdit extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { company, onCancel, onSubmit, onBack } = this.props;
    return (
      <Card
        title={<h1>Company Profile</h1>}
        extra={<Button icon='caret-left' onClick={onBack}>Back</Button>}
        className='edit-view wide'
      >
        <CompanyForm company={company.resource} onCancel={onCancel} onSubmit={onSubmit}/>
      </Card>
    );
  }
}

const myCompany = createSelector(
  state => state.profile.companyid,
  state => state.companies.data,
  (companyId, companies) => companies[companyId]
);

export const CompanyProfileEdit = compose(
  connect(
    (state, props) => {
      let company = myCompany(state, props);
      return {
        company
      };
    },
    (dispatch, props) => ({
      onCancel: () => props.history.push('/settings/company-profile'),
      onBack: () => props.history.push('/settings/company-profile'),
      onSubmit: (company) => {
        dispatch(updateCompany(company.id, company));
        props.history.push('/settings/company-profile');
      },
    })
  ),
  withLoading2(
    (_, dispatch) => dispatch(getMyCompany()),
    () => <Spinner name='line-scale'/>,
    (rest) => <div>{JSON.stringify(rest)}</div>,
    ['company']
  ),
)(_CompanyProfileEdit);



// WEBPACK FOOTER //
// ./src/components/Settings/CompanyProfileEdit.js